import '../polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import Login from './Login';
import {
    cellphone,
    CSRFtoken,
    redirectURI,
    hashContent,
    UserCheckout,
    SessionCheck,
    targetApplicationId,
    promo,
} from '../config/config';

ReactDOM.render(

    <Login
        cellphone={cellphone}
        CSRFtoken={CSRFtoken}
        redirectURI={redirectURI}
        hashContent={hashContent}
        UserCheckout={UserCheckout}
        SessionCheck={SessionCheck}
        targetApplicationId={targetApplicationId}
        promo = {promo}
    />,
    document.querySelector('#inn-container')
);
